import {Grid, ListItem, List,Button, Box, Tooltip} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import 'Agent/AgentDocumentation/components/ProducerCompliancePolicy.sass';
import {
  clear,
  getProducerCompliancePolicyAttachments,
} from 'Agent/AgentDocumentation/ducks/producerCompliancePolicyAttachments';
import { matchAsync} from 'Core/models/Async';
import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import ErrorMessage from 'Shared/components/ErrorMessage';
import FileDownloadButton from 'Shared/components/FileDownloadButton';
import Loading from 'Shared/components/Loading';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import { updatefeatureVariables } from 'Core/ducks/featureToggle';
import { createSnackbar } from 'Core/ducks/snackbar';
import { openFile } from 'Shared/utilities/fetchHelpers';

export const getFileNameWithoutExtension = (fileName: string) => fileName.slice(0, fileName.indexOf('.'));
export const getAttachmentSortOrderByName = (attachmentName: string) => {
  switch (attachmentName) {
    case 'AHL Business Associate Addendum':
      return 1;
    case 'AH EVB Do Not Call Policy':
      return 2;
    case 'AHL Internal Replacement Policy':
      return 3;
    case 'AHL Anti-Money Laundering Communication':
      return 4;
    case 'AH EVB Texting Policy':
      return 5;
    case 'Annual Producer Compliance Policy':
      return 6;
    default:
      return 7;
  }
};

type ProducerCompliancePolicyProps = {
  selectedAgency: AgencyFilters;
};

export const ProducerCompliancePolicy = (props: ProducerCompliancePolicyProps) => {
  const {selectedAgency} = props;
  const dispatch = useDispatch();
  const attachments = useSelector((state: ReducerState) => state.producerCompliancePolicyAttachments);
  const {featureVariables} = useSelector((state: ReducerState) => state.featureToggle);
  
 
  const getAttachmentsRef = useRef<HTMLHeadingElement>(null); 
  useEffect(() => {
    dispatch(getProducerCompliancePolicyAttachments(selectedAgency.encryptedIdentifier));
    let updateFeature = {...featureVariables, FOOTER_OPEN_DEFAULT : true};
    dispatch(updatefeatureVariables(updateFeature));
    return () => {
      dispatch(clear());
    };
  }, []);

    const fileExtension = `pdf`;
    const successResponse = `Sucessfully Downloaded!`;

  const getBulletinsDoc = (path: string) => {
    dispatch(createSnackbar("Request initiated!"))
    const response = openFile(path, fileExtension, successResponse);
  }

  return (
    <div className="producer-compliance-policy">
      <h1>Producer Compliance Policy</h1>
      { 
               <List className="producer-compliance-policy__attachments-list">
               {matchAsync(attachments, {
                 Loading: () => <Loading />,
                 Loaded: attachments => (
                   <>
                     {attachments
                       .sort(
                         (link1, link2) =>
                           getAttachmentSortOrderByName(getFileNameWithoutExtension(link1.rel!)) -
                           getAttachmentSortOrderByName(getFileNameWithoutExtension(link2.rel!))
                       )
                       .map(({rel, href}, index) => (
                        getFileNameWithoutExtension(rel!)==="Annual Producer Compliance Policy"&&
                         <ListItem key={rel!}>
                           <Grid
                             container
                             justify="space-between"
                             alignItems="center"
                             className="producer-compliance-policy__attachments-list__item"
                           >
                             <Grid item alignItems="center">
                               {`${getFileNameWithoutExtension(rel!)}`}
                             </Grid>
                             <Grid item>
                             <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="10vh"
                                
                              > 
                              <Tooltip title="Click here to view Annual Producer Compliance Policy pdf">
                               <Button 
                                 id="bulletins-view-details-btn"
                                 className="primary-action-button"
                                 color="primary"
                                 style={{ backgroundColor: 'transparent' }}
                                 onClick={() => getBulletinsDoc('/api' + href! +
                                 addFilterParameters({
                                   encryptedIdentifier: selectedAgency.encryptedIdentifier,
                                 }))}>link</Button>
                                 </Tooltip>
                                  <OpenInNewIcon/>
                                  </Box>
                             </Grid>
                           </Grid>
                         </ListItem>
                       ))}
                   </>
                 ),
                 Conflict: error => <ErrorMessage errorMessage={error.message} />,
                 ServerError: error => <ErrorMessage errorMessage={error.message} />,
                 Unauthorized: error => <ErrorMessage errorMessage={error.message} />,
                 NoData: error => <ErrorMessage errorMessage={error.message} />,
                 NoContent: error => <ErrorMessage errorMessage={error.message} />,
                 NotStarted: () => <Loading />
               })}
             </List>
              
           }
      <h3 ref={getAttachmentsRef} id="attachments">Attachments</h3>
      <List className="producer-compliance-policy__attachments-list">
        {matchAsync(attachments, {
          Loading: () => <Loading />,
          NotStarted: () => <Loading />,
          Loaded: attachments => (
            <>
              {attachments
                .sort(
                  (link1, link2) =>
                    getAttachmentSortOrderByName(getFileNameWithoutExtension(link1.rel!)) -
                    getAttachmentSortOrderByName(getFileNameWithoutExtension(link2.rel!))
                )
                .map(({rel, href}, index) => (
                  getFileNameWithoutExtension(rel!)!=='Annual Producer Compliance Policy'&&
                  <ListItem key={rel!}>
                    <Grid
                      container
                      justify="space-between"
                      alignItems="center"
                      className="producer-compliance-policy__attachments-list__item"
                    >
                      <Grid item alignItems="center">
                        {`${index + 1}. ${getFileNameWithoutExtension(rel!)}`}
                      </Grid>
                      <Grid item>
                        <FileDownloadButton
                          downloadedFileName={rel!}
                          displayTooltip={false}
                          relativeFileLocation={
                            '/api' + href! +
                            addFilterParameters({
                              encryptedIdentifier: selectedAgency.encryptedIdentifier,
                            })
                          }
                          onClick={() => getBulletinsDoc('/api' + href! +
                          addFilterParameters({
                            encryptedIdentifier: selectedAgency.encryptedIdentifier,
                          }))}
                        >
                          Download
                        </FileDownloadButton>
                      </Grid>
                    </Grid>
                  </ListItem>
                ))}
            </>
          ),
          Conflict: error => <ErrorMessage errorMessage={error.message} />,
          ServerError: error => <ErrorMessage errorMessage={error.message} />,
          Unauthorized: error => <ErrorMessage errorMessage={error.message} />,
          NoData: error => <ErrorMessage errorMessage={error.message} />,
          NoContent: error => <ErrorMessage errorMessage={error.message} />,
        })}
      </List>

    </div>
  );
};

export default ProducerCompliancePolicy;

